import { SNACKBAR_ACTIONS } from 'config';

export function openSnackbar(payload) {
    return {
        type: SNACKBAR_ACTIONS.OPEN_SNACKBAR,
        payload
    }
}
export function closeSnackbar(payload) {
    return {
        type: SNACKBAR_ACTIONS.CLOSE_SNACKBAR,
        payload
    }
}
export function handlerIncrease(payload) {
    return {
        type: SNACKBAR_ACTIONS.HANDLER_INCREASE,
        payload
    }
}
export function handlerDense(payload) {
    return {
        type: SNACKBAR_ACTIONS.HANDLER_DENSE,
        payload
    }
}
export function handlerIconVariants(payload) {
    return {
        type: SNACKBAR_ACTIONS.HANDLER_ICON_VARIANTS,
        payload
    }
}
